import React, { Suspense, lazy } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { StickyMobileBar } from "@/components/layout/StickyMobileBar";
import { ScrollToTop } from "@/components/layout/Section";
import { CookieBanner } from "@/components/CookieBanner";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import RequestQuote from "@/pages/RequestQuote";
import Contact from "@/pages/Contact";
import Areas from "@/pages/Areas";
import About from "@/pages/About";
import Reviews from "@/pages/Reviews";
import FAQ from "@/pages/FAQ";
import MovingTips from "@/pages/MovingTips";
import BlogPost from "@/pages/BlogPost";
import Privacy from "@/pages/Privacy";
import Cookies from "@/pages/Cookies";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminLeadDetail from "@/pages/admin/AdminLeadDetail";

const PublicLayout = ({ children }) => (
    <>
        <Header />
        <main className="min-h-[60vh]">{children}</main>
        <Footer />
        <StickyMobileBar />
        <FloatingWhatsApp />
        <CookieBanner />
    </>
);

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <Routes>
                    {/* Admin routes without public chrome */}
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<AdminLayout />}>
                        <Route index element={<AdminDashboard />} />
                        <Route path="leads" element={<AdminLeads />} />
                        <Route path="leads/:id" element={<AdminLeadDetail />} />
                    </Route>

                    {/* Public site */}
                    <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
                    <Route path="/services" element={<PublicLayout><Services /></PublicLayout>} />
                    <Route path="/services/:slug" element={<PublicLayout><ServiceDetail /></PublicLayout>} />
                    <Route path="/request-a-quote" element={<PublicLayout><RequestQuote /></PublicLayout>} />
                    <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
                    <Route path="/areas" element={<PublicLayout><Areas /></PublicLayout>} />
                    <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
                    <Route path="/reviews" element={<PublicLayout><Reviews /></PublicLayout>} />
                    <Route path="/faq" element={<PublicLayout><FAQ /></PublicLayout>} />
                    <Route path="/moving-tips" element={<PublicLayout><MovingTips /></PublicLayout>} />
                    <Route path="/moving-tips/:slug" element={<PublicLayout><BlogPost /></PublicLayout>} />
                    <Route path="/privacy-policy" element={<PublicLayout><Privacy /></PublicLayout>} />
                    <Route path="/cookie-policy" element={<PublicLayout><Cookies /></PublicLayout>} />
                    <Route path="/terms" element={<PublicLayout><Terms /></PublicLayout>} />
                    <Route path="*" element={<PublicLayout><NotFound /></PublicLayout>} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-right" richColors closeButton />
        </div>
    );
}

export default App;
